let _cb = null;
let _threeDS = null;

const ChargebeeInstance = () => {
  if (_cb) return _cb;

  const site = process.env.MIX_CHARGEBEE_SITE;
  const publishableKey = process.env.MIX_CHARGEBEE_PUBLISHABLE_KEY; // required for 3DS helper

  if (!site) throw new Error("MIX_CHARGEBEE_SITE is not set.");
  if (!publishableKey) throw new Error("MIX_CHARGEBEE_PUBLISHABLE_KEY is not set.");
  if (typeof window === "undefined" || !window.Chargebee) {
    throw new Error("Chargebee.js is not loaded on window.");
  }

  _cb = window.Chargebee.init({ site, publishableKey });
  return _cb;
};

// --- Existing helpers (still work) ---
export const openCheckout = (options) => ChargebeeInstance().openCheckout(options);
export const setPortalSession = (providerFn) => ChargebeeInstance().setPortalSession(providerFn);
export const openPortal = (callbacks) => ChargebeeInstance().createChargebeePortal().open(callbacks);

// --- 3DS Helper: lazy load and return handler ---
export const get3DSHandler = async () => {
  if (_threeDS) return _threeDS;
  const cb = ChargebeeInstance();
  _threeDS = await cb.load3DSHandler(); // creates a 3DS handler instance
  return _threeDS;
};

/**
 * Authorize a payment using RAW CARD DETAILS via 3DS.
 *
 * @param {Function} fetchPaymentIntent - async () => paymentIntent JSON from your backend
 * @param {Object} card - { firstName, lastName, number, cvv, expiryMonth, expiryYear }
 * @param {Object} [additionalData] - e.g. { billingAddress: { ... }, email, phone, plan, customerBillingAddress, shippingAddress, coupon }
 * @param {Object} [gatewaySDK] - optionally pass gateway SDK instance(s), e.g. { stripe }, { braintree }, { adyen }
 *
 * @returns {Promise<Object>} authorized paymentIntent (id can be used to create subscription/payment method)
 */
export const authorizeRawCardWith3DS = async (
  fetchPaymentIntent,
  card,
  additionalData = {},
  gatewaySDK = {}
) => {
  const threeDS = await get3DSHandler();

  // 1) Get/Create a Payment Intent on your server and set it on the handler
  const paymentIntent = await fetchPaymentIntent();
  await threeDS.setPaymentIntent(paymentIntent, gatewaySDK);

  // 2) Kick off 3DS with raw card details
  const intent = await threeDS.handleCardPayment(
    { card, additionalData },
    {
      change: () => {}, // optional callback on step changes
      success: () => {}, // optional: fires when 3DS auth succeeds
      error: (_intent, _error) => {}, // optional: handle 3DS auth failure
    }
  );

  return intent; // authorized paymentIntent (id can be used to create subscription/payment method)
};

export default ChargebeeInstance;